const { $ } = window;

/**
 * @usage tmpl(
 *      'hello {{ name }}!',
 *      { name: 'ash' }
 * );
 * => hello ash!
 *
 * @param {any} str
 * @param {any} data
 * @returns
 */
export function tmpl(pStr, pData) {
  let reg;
  let str = pStr;
  Object.keys(pData).forEach((item) => {
    reg = new RegExp(`{{ ${item} }}`, 'g');
    str = str.replace(reg, pData[item]);
  });
  return str;
}
export function getQueryString(pKey) {
  const a = window.location.search.substr(1).split('&');
  const b = {};
  for (let i = 0; i < a.length; i += 1) {
    const p = a[i].split('=');
    if (p.length === 2) {
      b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
    }
  }
  return b[pKey];
}

function initSetVCode($img) {
  $img.attr('src', `api/vcode.ashx?rnd=${Math.round(Math.random() * 999999)}`);
}

export function setVCode($img) {
  initSetVCode($img);
  $img.on('click', function click() {
    initSetVCode($(this));
  });
}

export function padLeft(str, lenght) {
  if (str.toString().length >= lenght) {
    return str;
  }
  return padLeft(`0${str}`, lenght);
}

// loading樣式
export function loadingView() {
  return '<div class="fetch-loading">'
                  + '<div class="spinner" role="status"><i class="icon icon-reload"></i> <span'
                          + ' class="sr-only">Loading...</span></div>'
              + '</div>';
}

export function setGA(id) {
  if (window.dataLayer !== undefined) {
    window.dataLayer.push({
      event: 'userID',
      event_userID: id,
    });
  }
}

export default {
  tmpl,
  getQueryString,
  setVCode,
  padLeft,
  loadingView,
  setGA,
};
